<template>
    <Transition name="fade">
        <div class="header flex items-center justify-between" :style="{ 'height': !isKeyboardShow ? '40px' : '0px' }">
            <div class="flex w-90% items-center justify-between absolute top-20px left-20px z-100"
                :class="{ 'is-keyboard-show': isKeyboardShow, 'is-keyboard-hide': !isKeyboardShow }">
                <div class="flex items-center">
                    <!-- 返回按钮 -->
                    <div class="header-left w-28px h-28px cursor-pointer" @click="handleBack">
                        <img src="@/assets/images/mine/left.webp" alt="" class="w-full h-full" />
                    </div>

                    <!-- 头像和信息 -->
                    <div class="header-center flex items-center ml-5px pl-2px! pr-6px!" @click="handleGotoDetail">
                        <div class="header-center-avatar w-31px h-31px overflow-hidden rounded-full">
                            <van-image :src="avatar" class="w-full h-full" fit="cover">
                                <template v-slot:loading>
                                    <div class="w-31px h-31px">
                                        <img src="@/assets/images/message/defaultAvatar.webp" alt=""
                                            class="w-full h-full" @load="handleLoad" />
                                    </div>
                                </template>
                            </van-image>
                        </div>

                        <!-- 名字和费用 -->
                        <div class="header-center-name ml-5px mr-5px">
                            <div class="color-#fff text-12px font-900 text-ellipsis overflow-hidden max-w-100px">
                                {{ name }}
                            </div>
                            <div class="text-10px flex item-center" v-if="!isShowFree">
                                <div class="flex item-center mt-2px">
                                    <img src="@/assets/images/home/crystal.webp" alt="" class="w-10px h-10px" />
                                </div>
                                <span class="color-#A0C3FF">
                                    {{ expenses }}
                                </span>
                                <span class="color-#A0C3FF">
                                    /Message
                                </span>
                            </div>
                            <div v-else class="text-10px color-#A0C3FF">
                                free
                            </div>
                        </div>

                        <!-- 点赞按钮 -->
                        <div v-if="shouldShowLike" class="w-25px cursor-pointer" @click.stop="handleLike"
                            :class="{ 'heartbeat': isLiking }">
                            <img src="@/assets/images/message/like.webp" alt="" class="w-full h-full"
                                v-if="isFavorite || isLiking" />
                            <img src="@/assets/images/message/like_no.webp" alt="" class="w-full h-full" v-else>
                        </div>
                    </div>
                </div>
                <div class="flex items-center">
                    <div class="physical_strength flex items-center justify-center mr-4px" v-if="isShowFree"
                        @click="handleShowStrength">
                        <div class="flex items-center mr-6px justify-center w-14px h-14px"> <img
                                src="@/assets/images/message/tili.svg" alt="" class="w-full h-full" /></div>
                        <div>
                            <span class="current">{{ userStore.getStrengthBalance() }}</span><span class="all">/{{
                                userStore.equipmentInformation?.config?.strengthMax }}</span>
                        </div>
                        <div class="countdown"
                            v-if="userStore.getStrengthBalance() < userStore.equipmentInformation?.config?.strengthMax">
                            {{ countdown }}</div>
                    </div>

                    <!-- 更多操作按钮 -->
                    <div class="flex gap-10px">
                        <div class="header-right w-28px h-28px cursor-pointer" @click.stop="handleHistory">
                            <img src="@/assets/images/chat/chatRecord/history.webp" alt="" class="w-full h-full" />
                        </div>
                        <div class="header-right w-28px h-28px cursor-pointer" @click.stop="$emit('showDrawer')">
                            <img src="@/assets/images/message/more.webp" alt="" class="w-full h-full" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/user'
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { theme } from '@/styles/theme'
import { useRouter } from 'vue-router'
interface Props {
    avatar?: string
    name?: string
    expenses?: number | string
    isFavorite?: boolean
    isKeyboardShow?: boolean
    isShowFree?: boolean
    id?: number
}

const props = withDefaults(defineProps<Props>(), {
    isKeyboardShow: false,
    isFavorite: true,
    isShowFree: false
})

const router = useRouter()

const emit = defineEmits<{
    (e: 'back'): void
    (e: 'gotoDetail'): void
    (e: 'like'): void
    (e: 'showDrawer'): void
}>()

const isLiking = ref(false)
const userStore = useUserStore()
const countdown = ref('00:00')
let countdownTimer: any = null

// 🔧 控制按钮显示：未点赞时显示，或者正在播放动画时也显示
const shouldShowLike = computed(() => {
    return !props.isFavorite || isLiking.value
})

/**
 * 计算距离下一个整点的时间
 */
const calculateCountdown = () => {
    const now = new Date()
    const nextHour = new Date(now)
    nextHour.setHours(now.getHours() + 1, 0, 0, 0) // 下一个整点

    const diff = nextHour.getTime() - now.getTime()

    const hours = Math.floor(diff / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((diff % (1000 * 60)) / 1000)

    countdown.value = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}

/**
 * 返回
 */
const handleBack = () => {
    emit('back')
}

/**
 * 跳转详情
 */
const handleGotoDetail = () => {
    emit('gotoDetail')
}

const handleShowStrength = () => {
    if (userStore.getStrengthBalance() <= 0) {
        if (typeof window !== 'undefined' && (window as any).openInsufficientPhysicalStrengthDialog) {
            ; (window as any).openInsufficientPhysicalStrengthDialog()
        }
    }

}

const handleHistory = () => {
    router.push({ name: 'History',query:{
        id: props.id
    } })
}

/**
 * 点赞
 */
const handleLike = () => {
    // 触发心跳动画
    isLiking.value = true

    // 先触发父组件更新状态（让图标立即点亮）
    emit('like')

    // 动画结束后，隐藏按钮
    setTimeout(() => {
        isLiking.value = false
    }, 650) // 稍微延长一点，确保动画完整播放后再消失
}

/**
 * 图片加载完成
 */
const handleLoad = () => {
    // 图片加载完成回调
}

/**
 * 组件挂载时启动倒计时
 */
onMounted(() => {
    calculateCountdown()
    countdownTimer = setInterval(calculateCountdown, 1000)
})

/**
 * 组件卸载时清理定时器
 */
onUnmounted(() => {
    if (countdownTimer) {
        clearInterval(countdownTimer)
        countdownTimer = null
    }
})
</script>

<style scoped lang="scss">
.header-center {
    background-color: v-bind('theme.colors.backgroundTertiary');
    padding: 2px 5px;
    border-radius: 25px;
}

.header-center-id {
    color: v-bind('theme.colors.textPrimary');
}

/* 心跳动画 */
.heartbeat {
    animation: heartbeat 0.6s ease-in-out;
}

@keyframes heartbeat {
    0% {
        transform: scale(1);
    }

    14% {
        transform: scale(1.3);
    }

    28% {
        transform: scale(1);
    }

    42% {
        transform: scale(1.3);
    }

    70% {
        transform: scale(1);
    }
}

.is-keyboard-show {
    transform: translateY(-100px);
    transition: transform 0.5s ease-in-out;
    -webkit-transition: transform 0.5s ease-in-out;
    -moz-transition: transform 0.5s ease-in-out;
    -ms-transition: transform 0.5s ease-in-out;
    -o-transition: transform 0.5s ease-in-out;
    top: -40px;
}

.is-keyboard-hide {
    transform: translateY(0);
    transition: transform 0.5s ease-in-out;
    -webkit-transition: transform 0.5s ease-in-out;
    -moz-transition: transform 0.5s ease-in-out;
    -ms-transition: transform 0.5s ease-in-out;
    -o-transition: transform 0.5s ease-in-out;
    top: 20px;
}

// 淡入淡出动画
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.physical_strength {
    // width: 52px;
    padding: 0 8px;
    height: 30px;
    background: rgba(1, 3, 27, 0.5);
    border-radius: 15px;

    .all {
        color: rgba(255, 255, 255, 0.4);

    }

    .countdown {
        margin-top: 2px;
        margin-left: 6px;
        font-size: 9px;
        color: rgba(255, 255, 255, 0.4);
    }

    // opacity: 0.5;
}
</style>
